// @ts-nocheck


import React, { useState } from 'react';
import Button from 'antd/lib/button';





import AssignmentLimitRow from './AssignmentLimitRow';
import { Row, Spoiler } from '../../../../components/ui';


















/**
 * Компонент строки для групп лимитов в закреплении
 */
export default ({ group, index, onChange, onSave, editable }) => {
  const [hasChanges, setHasChanges] = useState(false);

  const handleChangeLimit = (
  limitIndex,
  name,
  value) =>
  {
    const { operationLimits } = group;
    const copy = [...operationLimits];
    copy[limitIndex][name] = value;

    onChange(index, 'operationLimits', copy);
    setHasChanges(true);
  };

  const handleSave = async () => {
    await onSave(group, index);
    setHasChanges(false);
  };

  return (
    <>
      <Spoiler
        label={group.name}
        labelStyles={{
          background: '#F0F4F8',
          color: '#838D96',
          height: '45px'
        }}
        defaultExpanded
        iconPlacement="left">

        {group.operationLimits.map((limit, index) =>
        <AssignmentLimitRow
          editable={editable}
          onChange={handleChangeLimit}
          limit={limit}
          index={index}
          key={index} />

        )}
        {editable && hasChanges &&
        <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleSave} size="small" type="primary">
              Сохранить изменения
            </Button>
          </Row>
        }
      </Spoiler>
    </>);

};
